import InfiniteScroll from "./components/infiniteScroll";
import CategoryDropdown from "./components/CategoryDropdown";

window.addEventListener("DOMContentLoaded", (event) => {
  let infiniteScroll;

  const posts = document.querySelector(".blog-items");
  if (posts) {
    const endpoint = document.querySelector(".endpoint");

    infiniteScroll = new InfiniteScroll(posts, {
      fetchUrl: wtm_global_vars._wtm_rest + endpoint.innerHTML,
      type: "html",
    });

    infiniteScroll.init();
    endpoint.remove();
  }

  new CategoryDropdown(infiniteScroll, posts).init();
});
